import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import { Select } from "../Components";
import { getTranslateByScope } from "../i18n";
import { getCustomers } from "../selectors";
import AppContext from "../AppContext";
import { CustomerSelectItem } from "./CustomerSelectItem";
import "./SelectCustomerDropdown.scss";

const translate = getTranslateByScope("app.selectCustomer");

export const mapCustomer = (customer) => ({
  value:
    customer.Name +
    customer.CustomerNo__c +
    customer.BillingCity +
    customer.BillingPostalCode +
    customer.BillingStreet,
  id: customer.Id,
  label: CustomerSelectItem(customer),
  BillingPostalCode: customer.BillingPostalCode,
  BillingStreet: customer.BillingStreet,
  BillingCity: customer.BillingCity,
  BillingCountry: customer.BillingCountry,
  Blocked__c: customer.Blocked__c,
  CustomerNo__c: customer.CustomerNo__c,
  Customer_No_blocked_Text__c: customer.Customer_No_blocked_Text__c,
});

const mapCustomersToSelect = (customers) =>
  customers ? customers.map(mapCustomer) : [];

const SelectCustomerDropdown = ({ selectCustomer, value }) => {
  const context = useContext(AppContext);
  const [mappedCustomers, setMappedCustomers] = useState();
  const customers = getCustomers(context);

  let filteredCustomers = customers;

  if (context.state.lowa) {
    const lowaCustomer = context.state.lowaCustomer;
    filteredCustomers = [];

    if (lowaCustomer && Object.keys(lowaCustomer).length > 0) {
      const lowaGroup = lowaCustomer.LowaGroup__c;
      filteredCustomers = customers.filter((c) => {
        // "franchise" can ONLY see their own location
        if (lowaGroup === null || lowaGroup === undefined) {
          return false;
        }

        if (
          lowaGroup.toLowerCase() === "franchise" ||
          lowaGroup.toLowerCase() === "franchise de"
        ) {
          return c.Id === lowaCustomer.Id;
        }

        return c.LowaGroup__c === lowaGroup;
      });
    }
  }

  useEffect(() => {
    if (mappedCustomers || _.isEmpty(filteredCustomers)) return;
    setMappedCustomers(mapCustomersToSelect(filteredCustomers));
  }, [filteredCustomers, mappedCustomers]);

  return (
    <Select
      key={value}
      value={value ? mapCustomer(value) : null}
      onChange={selectCustomer}
      options={mappedCustomers}
      placeholder={translate("select.placeholder")}
    />
  );
};

export default SelectCustomerDropdown;
